import { h } from 'preact'

import { Icon } from '../../shared/Icons/Icons'
import { Message, MessageProps } from '../../../../lib/intl/Message'

import styles from './shared.css'

export function InfoHeading({ children, ...props }: MessageProps) {
  return (
    <h3 class={styles.infoHeading}>
      <Icon type="info" class={styles.infoHeading__icon} />
      <Message {...props} />
      {children}
    </h3>
  )
}
